"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
var react_1 = require("react");
function useDebounce(callback, delay) {
    var _a = (0, react_1.useState)(null), callPref = _a[0], setCallPref = _a[1];
    (0, react_1.useEffect)(function () {
        if (callPref) {
            var fire = function () {
                setCallPref(null);
                callback.apply(void 0, callPref.args);
            };
            var fireAt = callPref.at + delay;
            var fireIn = Math.max(fireAt - Date.now(), 0);
            var id_1 = setTimeout(fire, fireIn);
            return function () { return clearTimeout(id_1); };
        }
    }, [callback, callPref, delay]);
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return setCallPref({ at: Date.now(), args: args });
    };
}
exports.useDebounce = useDebounce;
//# sourceMappingURL=debounce.js.map